import systemConfig from "./systemConfig"

export const Config = {
	sys:systemConfig
}

export default Config